// type ResponseHandler = 'content-type' | 'json' | 'text' | ((response: Response) => Promise<any>);
const defaultRtkValidateStatus = (response) => response.status >= 200 && response.status <= 299;
export const blobResponseHandler = (response) => defaultRtkValidateStatus(response) ? response.blob() : response.json();
